const state = {
  show: false
}

const mutations = {
  showSystem (state, item) {
    state.show = item
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
